import React from 'react';
import { Button, CircularProgress } from '@mui/material';

/**
 * Loading (spinner) or error-with-retry element for a query still without
 * data, or null once it has data — callers render their content then (a
 * failed background refetch keeps showing the data it had).
 */
export const renderQueryState = (query, messages) => {
	if (query.isPending) {
		return (
			<div className="oem-data-modal-loading" role="status">
				<CircularProgress size={20} />
				{messages['oemDataModal_remote_loading']}
			</div>
		);
	}
	if (query.isError && query.data === undefined) {
		return (
			<div>
				<p className="oem-data-modal-error">{messages['oemDataModal_remote_error']}</p>
				<Button variant="outlined" size="small" onClick={() => query.refetch()}>
					{messages['oemDataModal_retry']}
				</Button>
			</div>
		);
	}
	return null;
};
